export default function imageonload() {
  'ngInject'
  var directive = {
    restrict: 'A',
    link: imageLink,
  }

  return directive

  function imageLink(scope, element) {
    element.bind('load', function() {
      scope.$apply()
    })
  }
}
